export const buildErrorPayload = (error) => {
  if (!(error instanceof Error)) {
    return { errorMessage: JSON.stringify(error), nonErrorThrown: true };
  }

  return { errorMessage: error.message };
};
